import { Search } from "lucide-react";

interface Props {
  q: string;
  onQChange: (q: string) => void;
  status: string;
  onStatusChange: (status: string) => void;
  statusOptions: { value: string; label: string }[];
  placeholder?: string;
}

/**
 * Search + status dropdown bar.
 * Pure client-side filtering driven by parent.
 */
export default function SearchStatusBar({
  q, onQChange, status, onStatusChange, statusOptions, placeholder,
}: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => onQChange(e.target.value)}
          placeholder={placeholder ?? "搜索名称、ID"}
          className="w-full rounded-md border border-border bg-background pl-9 pr-3 py-1.5 text-sm"
        />
      </div>
      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        className="rounded-md border border-border bg-background px-3 py-1.5 text-sm min-w-[120px]"
      >
        {statusOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}
